export default __webpack_public_path__ + "static/media/no-pending-post.78b6d049.svg";